export const exerciseDataNameToLabelRemapper = (exercise) => {
	switch (exercise) {
		case 'push-ups':
			return 'Pushups';
		case 'crunches':
			return 'Crunches';
		case 'squats':
			return 'Squats';
		case 'jumping jacks':
			return 'Jumping Jacks';
		case 'pull-ups':
			return 'Pullups';
		default:
			throw new Error("Invalid exercise type when converting name to label:" +  exercise);
	}
}

export const exerciseLabelToDataNameRemapper = (exercise) => {
	switch (exercise) {
		case 'Pushups':
			return 'push-ups';
		case 'Crunches':
			return 'crunches';
		case 'Squats':
			return 'squats';
		case 'Jumping Jacks':
			return 'jumping jacks';
		case 'Pullups':
			return 'pull-ups';
		default:
			throw new Error("Invalid exercise typ when converting label to name:" + exercise);
	}
}
